import { useState, useEffect } from "react";
import { Row, Col, Tabs, Space } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

import DataTable from "../DataTable";
import CopyableCell from "../CopyableCell";

const { TabPane } = Tabs;

interface IAgentProps {
  agents: any;
  showEditModal: Function;
  handleDelete: Function;
  filtered: any;
}

let data: any = [];
let setTimeoutId = -1;

const AgentTable: React.FC<IAgentProps> = ({
  agents,
  showEditModal,
  handleDelete,
  filtered,
}) => {
  const [active, setActive] = useState([]);
  const [inactive, setInactive] = useState([]);
  const [state, setState] = useState({
    loading: true,
    activeKey: "1",
    pagination: {
      pageSize: 15,
      position: ["bottomRight"],
      total: 0,
      current: 1,
      hideOnSinglePage: true,
    },
    searchItem: "",
  });

  const fetchActive = async (params = {}) => {
    try {
      const filtered = agents.filter(
        (item: any) => item.Status.Status === "Active"
      );

      const pagination = state.pagination;
      pagination.total = filtered.length.toString();

      setState({
        ...state,
        loading: false,
        pagination,
        ...params,
      });

      setActive(filtered);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchInActive = async (params = {}) => {
    try {
      const filtered = agents.filter(
        (item: any) => item.Status.Status === "Inactive"
      );

      const pagination = state.pagination;
      pagination.total = filtered.length.toString();

      setState({
        ...state,
        loading: false,
        pagination,
        ...params,
      });
      setInactive(filtered);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchActive();
    fetchInActive();
  }, [agents, filtered]);

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    const pager = { ...state.pagination };
    pager.current = pagination.current;
    setState({
      ...state,
      pagination: pager,
    });

    const params = {
      pageSize: pagination.pageSize,
      page: pagination.current,
      sortField: sorter.field,
      sortOrder: sorter.order,
      ...filters,
    };
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
    },
    {
      title: "Surname",
      dataIndex: "Surname",
    },
    {
      title: "Email",
      dataIndex: "Email",
      render: (v: any) => <CopyableCell value={v} />,
    },
    {
      title: "Cellphone Number",
      dataIndex: "Cellphone Number",
    },
    {
      title: "Group",
      dataIndex: "Group",
    },
    {
      dataIndex: "Action",
      render: (_: any, record: any) => (
        <Space size="middle">
          <EditOutlined
            onClick={() => showEditModal(record)}
            style={{ color: "blue" }}
          />
          <DeleteOutlined
            onClick={() => handleDelete(record.id)}
            style={{ color: "red" }}
          />
        </Space>
      ),
    },
  ];

  const tabPanes = [
    {
      key: "1",
      title: "Active",
      content: (
        <DataTable
          persistKey="agents"
          dataSource={active}
          columns={columns}
          loading={state.loading}
          pagination={state.pagination}
          onChange={handleTableChange}
        />
      ),
      count: active.length,
    },
    {
      key: "2",
      title: "Inactive",
      content: (
        <DataTable
          persistKey="agents"
          dataSource={inactive}
          columns={columns}
          loading={state.loading}
          pagination={state.pagination}
          onChange={handleTableChange}
        />
      ),
      count: inactive.length,
    },
  ];

  const changeTab = (key: any) => {
    setState({
      ...state,
      activeKey: key,
      loading: false,
    });
  };

  return (
    <>
      <Row>
        <Col span={24}>
          <Tabs
            type="card"
            defaultActiveKey={state.activeKey}
            activeKey={state.activeKey}
            onChange={changeTab}
          >
            {tabPanes.map((pane) => (
              <TabPane
                key={pane.key}
                tab={
                  <>
                    <span>{pane.title}</span>
                    <span
                      style={{
                        color: "#B0B0B0",
                        fontWeight: "300",
                        marginLeft: "3px",
                        fontSize: "12px",
                      }}
                    >
                      ({pane.count})
                    </span>
                  </>
                }
              >
                {pane.content}
              </TabPane>
            ))}
          </Tabs>
        </Col>
      </Row>
    </>
  );
};

export default AgentTable;
